module.exports = __webpack_public_path__ + "media/images/logo-sm-f2749dea70403685e72a614dc50031fa.png";